import { makeStyles } from '@material-ui/core/styles';
import { DIMENSIONS, SPACING } from '../../styles/constants';

export const useStyles = makeStyles(theme => ({
	quickFiltersContainer: {
		marginBottom: theme.spacing(SPACING)
	},
	tableSection: {
		display: 'flex',
		[theme.breakpoints.down('xs')]: {
			display: 'block'
		}
	},
	filtersPanel: {
		width: DIMENSIONS.FILTERS_PANEL_WIDTH,
		minWidth: DIMENSIONS.FILTERS_PANEL_MIN_WIDTH,
		flexShrink: 0,
		[theme.breakpoints.down('xs')]: {
			width: '100%'
		},
		overflowX: 'auto'
	},
	productsTable: {
		flexGrow: 1,
		width: `calc(100% -
               ${DIMENSIONS.FILTERS_PANEL_WIDTH + theme.spacing(SPACING)}px)`,
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		}),
		marginLeft: -DIMENSIONS.FILTERS_PANEL_WIDTH,
		[theme.breakpoints.down('xs')]: {
			width: '100%',
			marginLeft: 0,
			marginTop: theme.spacing(SPACING)
		}
	},
	productsTableShift: {
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen
		}),
		[theme.breakpoints.up('sm')]: {
			marginLeft: theme.spacing(SPACING)
		}
	}
}));
